import { supabase } from './supabaseClient';

/**
 * Load commissions based on user role
 */
export async function loadCommissions(currentUser) {
  if (!supabase || !currentUser) return { userCommissions: [], allCommissions: [] };
  
  try {
    let query = supabase
      .from('commissions')
      .select(`
        *,
        restaurant:restaurants(
          name,
          area
        )
      `)
      .order('created_at', { ascending: false });
    
    // Non-admin users only see their own commissions
    if (currentUser.role !== 'admin' && currentUser.role !== 'sales_manager') {
      query = query.eq('user_id', currentUser.id);
    }
    
    const { data, error } = await query;
    
    if (error) throw error;
    
    const commissions = data || [];
    
    // Return based on role
    if (currentUser.role === 'admin' || currentUser.role === 'sales_manager') {
      return { allCommissions: commissions, userCommissions: [] };
    } else {
      return { userCommissions: commissions, allCommissions: [] };
    }
  } catch (err) {
    console.error('❌ Error loading commissions:', err);
    throw err;
  }
}

/**
 * Mark commission as paid
 */
export async function markCommissionPaid(commissionId, userId, note = null) {
  if (!supabase) return false;
  
  try {
    const { error } = await supabase
      .from('commissions')
      .update({
        status: 'paid',
        paid_at: new Date().toISOString(),
        paid_by: userId,
        notes: note || null,
      })
      .eq('id', commissionId);
    
    if (error) throw error;
    return true;
  } catch (err) {
    console.error('❌ Error marking commission paid:', err);
    throw err;
  }
}

/**
 * Bulk mark commissions as paid
 */
export async function bulkMarkCommissionsPaid(commissionIds, userId, note = null) {
  if (!supabase || commissionIds.length === 0) return false;
  
  try {
    const { error } = await supabase
      .from('commissions')
      .update({
        status: 'paid',
        paid_at: new Date().toISOString(),
        paid_by: userId,
        notes: note || null,
      })
      .in('id', commissionIds);
    
    if (error) throw error;
    return true;
  } catch (err) {
    console.error('❌ Error bulk marking commissions paid:', err);
    throw err;
  }
}

/**
 * Calculate total earnings for a user
 */
export function calculateTotalEarnings(commissions) {
  return commissions.reduce((total, comm) => {
    return total + (comm.status === 'paid' ? parseFloat(comm.amount) : 0);
  }, 0);
}

/**
 * Calculate pending earnings for a user
 */
export function calculatePendingEarnings(commissions) {
  return commissions.reduce((total, comm) => {
    return total + (comm.status === 'pending' ? parseFloat(comm.amount) : 0);
  }, 0);
}
